import { isMapboxSbxMode, MAPBOX_SBX_ACCESS_TOKEN } from "@phc/common"

export const AUTH0_DOMAIN = import.meta.env.AUTH0_DOMAIN
export const AUTH0_CLIENT_ID = import.meta.env.AUTH0_CLIENT_ID

export const AUTH0_AUDIENCE = import.meta.env.AUTH0_AUDIENCE

export const KEYCLOAK_URL = import.meta.env.KEYCLOAK_URL
export const KEYCLOAK_REALM = import.meta.env.KEYCLOAK_REALM
export const KEYCLOAK_CLIENT_ID = import.meta.env.KEYCLOAK_CLIENT_ID

export const UPLOAD_CACHE_KEY = import.meta.env.UPLOAD_CACHE_KEY

export const MAPBOX_ACCESS_TOKEN = isMapboxSbxMode
  ? MAPBOX_SBX_ACCESS_TOKEN
  : import.meta.env.MAPBOX_API_KEY
